import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const ObjectivesPage = () => {
  const objectives = [
    {
      icon: "💪",
      title: "Emotional Resilience",
      description: "Enhance survivors' emotional resilience through targeted support programs",
      details: "We provide comprehensive programs designed to strengthen emotional resilience, helping individuals develop coping mechanisms and build inner strength to overcome trauma and adversity."
    },
    {
      icon: "🤝",
      title: "Community Networks",
      description: "Strengthen and create accessible community support networks for survivors",
      details: "Building robust community networks that connect survivors with resources, support systems, and peer groups, ensuring no one faces their journey alone."
    },
    {
      icon: "🏥",
      title: "Psychosocial Care",
      description: "Improve access to quality psychosocial care services",
      details: "Expanding access to professional psychosocial services that address both psychological and social aspects of well-being, ensuring comprehensive care for all who need it."
    },
    {
      icon: "🎓",
      title: "Autonomy & Self-Determination",
      description: "Promote survivor autonomy and self-determination",
      details: "Empowering individuals to make their own choices, regain control over their lives, and determine their own paths to recovery and growth."
    },
    {
      icon: "🌟",
      title: "Reduce Stigma",
      description: "Reduce community-level stigma associated with seeking mental health support",
      details: "Working to change attitudes and perceptions about mental health, creating an environment where seeking help is seen as a sign of strength, not weakness."
    },
    {
      icon: "📚",
      title: "Education & Awareness",
      description: "Promote education and awareness on critical social issues",
      details: "Conducting community education programs that inform and empower individuals with knowledge about their rights, health, and available support services."
    }
  ];

  return (
    <div className="objectives-page">
      <div className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <div className="page-badge">Our Goals</div>
            <h1 className="page-title-animated">Our Objectives</h1>
            <p className="page-subtitle">
              Strategic goals for lasting impact and sustainable community development
            </p>
          </div>
        </div>
      </div>

      <div className="container page-content">
        <section className="objectives-intro">
          <div className="overview-content">
            <h2 className="overview-title">Driving Meaningful Change</h2>
            <div className="overview-text">
              <p>
                CAEI's objectives are designed to create comprehensive, sustainable impact across multiple dimensions of community well-being. Each objective represents a critical area where we focus our efforts to support individuals, strengthen communities, and promote lasting positive change.
              </p>
              <p className="highlight-text">
                Through strategic planning and community collaboration, we work systematically toward achieving these objectives, measuring our progress and adapting our approaches to ensure maximum effectiveness.
              </p>
            </div>
          </div>
        </section>

        <section className="objectives-detailed">
          <div className="objectives-grid-detailed">
            {objectives.map((objective, index) => (
              <div className="objective-card-detailed" key={index}>
                <div className="objective-icon-wrapper">
                  <div className="objective-icon-large">{objective.icon}</div>
                </div>
                <div className="objective-content">
                  <h3>{objective.title}</h3>
                  <p className="objective-description">{objective.description}</p>
                  <p className="objective-details">{objective.details}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <div className="page-nav-footer">
          <Link to="/" className="btn btn-primary">← Back to Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ObjectivesPage;
